import {z} from 'zod';
import {zNumberToString} from '@brunata-angular/util';

const buildingDataSchema = z.object({
    buildingName: z.string().nullable(),
    address1: z.string().nullable(),
    address2: z.string().nullable(),
    buildingNo: zNumberToString,
    postalCode: z.string().nullable(),
    city: z.string().nullable(),
});
export type BuildingData = z.infer<typeof buildingDataSchema>;

export const buildingIdPairSchema = z
    .object({
        propertyNo: z.string(),
        branchNo: z.string(),
    })
    .transform(it => it.propertyNo + '-' + it.branchNo);

export const buildingSchema = z.object({
    building: buildingDataSchema,
    buildingIdPairs: z.array(buildingIdPairSchema).nullable(),
});

export type Building = z.infer<typeof buildingSchema>;
